// Serves Cloudinary images resized to their display width, in the lightest format the browser supports.
export const optimizedImage = (url: string | undefined, width: number): string | undefined => {
  if (!url || !url.includes('res.cloudinary.com') || !url.includes('/upload/')) return url;
  return url.replace('/upload/', `/upload/f_auto,q_auto,c_limit,w_${width}/`);
};
